<template>
  <div class="dialog-post-upload" v-if="show">
    <div class="content">
      <i class="el-icon-close" @click="handleClose"></i>
      <div class="title">AI批量岗位生成</div>
      <div class="t-info flex">
        <span>1.上传招聘信息文件</span>
        <span class="arrow" />
        <span>2.AI识别并批量生成岗位信息</span>
        <span class="arrow" />
        <span>3.确认信息并保存</span>
      </div>
      <div class="up-text">您可以将公司招聘公告文档上传，AI将会自动识别岗位内容，并根据平台要求智能补充招聘信息，形成批量待发布岗位！目前算力紧张，最多支持5条岗位招聘信息批量生成、发布。</div>

      <el-upload class="upload-file" drag :action="`${PRO_URL}/files/upload`" :multiple="false"
        :headers="headers" :before-upload="beforeAvatarUpload" :on-success="handleAvatarSuccess">
        <img src="~@/assets/images/icon_file.png" class="file-logo" />
        <template v-if="!fileInfo.upload_file_id">
          <!-- <i class="el-icon-upload"></i> -->
          <div class="el-upload__text"><em>点击上传</em>或将文件拖到此区域</div>
          <div class="el-upload__tip" slot="tip">上传格式为xls、docx、xlsx、pdf文件，大小在60M以内</div>
        </template>
        <div class="el-upload-success" v-else><i class="el-icon-upload-success el-icon-circle-check" />上传完成</div>
      </el-upload>

      <el-button type="primary" @click="handleSubmit">立即生成岗位</el-button>

      <div class="analysis-box" v-show="dialogAnalysis">
        <el-progress :percentage="progress"></el-progress>
        <div class="analysis-text">{{ precentText }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      headers: {
        //"Authorization": "Bearer app-5pzFzJkmKyCmYiejOLG5xCHs", //dev 
        "Authorization": "Bearer app-CT7SB24DI5rSmvB4QFiTHvCq", //pro 
      },
      fileInfo: {
        transfer_method: 'local_file',
        type: 'document',
        upload_file_id: '',
        url: ''
      },
      dialogAnalysis: false,
      progress: 0,
      timer: null,
      precentText: '',
      PRO_URL: 'https://aidev.zlznai.com/v1',
      // PRO_TOKEN: '',
      DEV_URL: 'https://df-api.yifu-tech.com/dify',
      // DEV_TOKEN: ''
    }
  },
  watch: {
    progress (val) {
      if (val < 30) {
        this.precentText = 'ai正在解析文件...'
      } else if (val >= 30 && val < 70) {
        this.precentText = 'ai正在补充生成招聘要素...'
      } else if (val >= 70 && val < 90) {
        this.precentText = '系统正在汇总整理...'
      } else if (val == 99){
        this.precentText = 'ai正在生成岗位信息...'
        clearInterval(this.timer)
      }
    }
  },
  methods: {
    beforeAvatarUpload(file) {

      const allowedExtensions = ['xlsx', 'xls', 'docx', 'pdf']
      const fileExtension = file.name.split('.').pop().toLowerCase()
      if (!allowedExtensions.includes(fileExtension)) {
        this.$message.error('只能上传 XLSX, XLS, DOCX, PDF 文件');
        return false
      }

      const maxSize = 60 * 1024 * 1024; // 60MB
      if (file.size > maxSize) {
        this.$message.error('文件大小不能超过 60MB');
        return false
      }

      return true
    },
    handleAvatarSuccess(res, file) {
      this.fileInfo.upload_file_id = res.id
    },
    handleSubmit() {
      this.dialogAnalysis = true
      this.startProgressBar(9 * 1000)

      // const url = 'https://df-api.yifu-tech.com/dify/workflows/run'
      const url = `${this.PRO_URL}/workflows/run`
      const data = {
        // inputs: {
        //   question_type: '3',
        // },
        // user: 'abc-123',
        // files: [this.fileInfo]
        
        inputs: {
          question_type: '3',
          file: this.fileInfo
        },
        user: 'abc-123',
        // files: [this.fileInfo]
      }
      this.axios.post(
        url,
        data,
        {
          headers: {
            //"Authorization": "Bearer app-5pzFzJkmKyCmYiejOLG5xCHs", // dev
            "Authorization": "Bearer app-CT7SB24DI5rSmvB4QFiTHvCq", //pro 
          }
        }
      ).then(res => {
        console.log(res)
        this.progress = 100
        this.timer && clearInterval(this.timer)
        this.dialogAnalysis = false

        res = JSON.parse(res.data.outputs.text)
        if (res.code === 200 && res.data && res.data.length) {
          this.$store.commit('setAiBatchData', JSON.stringify(res.data))
          this.$router.push({ path: "/index/posts/ai" })
        } else {
          this.$message.error(res.msg || '解析失败，请重试～');
        }
      }).catch(err => {
        this.dialogAnalysis = false
        console.error('axios error', err)
        this.$message.error('上传失败，请重试');
      })
    },
    handleClose() {
      this.$emit('update:show', false)
    },
    startProgressBar(duration) {
      this.progress = 0
      const interval = 100; // 每隔 100 毫秒更新一次进度
      const increment = 100 / (duration / interval); // 每次递增的百分比

      this.timer = setInterval(() => {
        this.progress = parseInt(this.progress + increment); // 更新进度
        if (this.progress > 99) {
          this.progress = 99; // 确保进度不会超过 100%
        }
      }, interval);
    }
  },
  beforeDstroy() {
    clearInterval(this.timer);
  }
}
</script>

<style lang="less" scoped>
.dialog-post-upload {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #0000006b;
  z-index: 99;

  .content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 752px;
    background: linear-gradient(180deg, #EAF3FF 0%, #ECFAFF 100%), radial-gradient(48% 41% at 70% 89%, rgba(149, 234, 229, 0.7) 0%, rgba(158, 239, 227, 0) 100%), radial-gradient(41% 79% at 9% -1%, #95EAE5 0%, rgba(158, 239, 227, 0) 100%), radial-gradient(19% 37% at 50% 1%, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
    border-radius: 12px;

    padding: 36px;
  }

  .el-icon-close {
    position: absolute;
    top: 20px;
    right: 20px;
    font-size: 12px;
    cursor: pointer;
  }

  .title {

    font-weight: bold;
    font-size: 24px;
    color: #000000;
    line-height: 24px;
    margin-bottom: 30px;
    margin-bottom: 10px;
  }

  .t-info {
    font-size: 15px;
    color: #0984FA;
    line-height: 20px;
    font-size: 15px;
    color: #0984FA;

    .arrow {
      display: inline-block;
      width: 54px;
      height: 10px;
      margin: 0 28px;
      background: url('~@/assets/images/index/icon_arrow_ai.png')no-repeat center/100% 100%;
    }
  }

  .up-text {
    width: 680px;
    height: 48px;
    font-weight: 400;
    font-size: 15px;
    color: #000000;
    line-height: 24px;
    text-align: left;
    font-style: normal;
    margin-bottom: 24px;
  }

  .upload-file {
    position: relative;
    height: 220px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px dashed #BAC4D7;
    margin-bottom: 25px;

    /deep/ .el-upload-dragger {
      border: none !important;
    }

    /deep/ .el-upload__tip {
      position: absolute;
      bottom: 15px;
      left: 50%;
      transform: translateX(-50%);
      font-size: 14px;
      color: rgba(96, 98, 102, 1);
    }

    /deep/ .el-upload-list {
      position: absolute;
      top: 114px;
      left: 50%;
      transform: translateX(-50%);
    }

    .file-logo {
      margin-top: 40px;
      width: 56px;
      height: 56px;
    }
    .el-upload-success {
      margin-top: 47px;
      color: rgba(129, 131, 135, 1);
      font-size: 14px;
    }
    /deep/ .el-icon-upload-success {
      color: rgba(9, 132, 250, 1) !important;
    }
  }

  .el-button--primary {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    width: 212px;
    height: 46px;
    background: linear-gradient(90deg, #057CF9 0%, #1AAFFD 100%);
    border-radius: 4px;
  }

  .analysis-box {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 9;
    background: linear-gradient(180deg, #EAF3FF 0%, #ECFAFF 100%), radial-gradient(496% 41% at 70% 89%, rgba(149, 234, 229, 0.7) 0%, rgba(158, 239, 227, 0) 100%), radial-gradient(423% 79% at 9% -1%, #95EAE5 0%, rgba(158, 239, 227, 0) 100%), radial-gradient(34% 42% at 50% 50%, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .el-progress {
      width: 277px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// PostBatchUpload.vue?c461f0b6